exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".backButton__button___b7gT5 {\n  border: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 14px;\n  font-weight: bold;\n  border-radius: 5px;\n  cursor: pointer;\n  width: 262px;\n  height: 50px; }\n  @media (max-width: 576px) {\n    .backButton__button___b7gT5 {\n      display: block;\n      width: 100%;\n      text-align: center;\n      background-color: white;\n      margin-left: 0;\n      box-shadow: none; } }\n\n.backButton__button___b7gT5 {\n  width: 60px;\n  box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.05);\n  background-color: #ffffff; }\n  .backButton__button___b7gT5 .backButton__icon___1bQU_ {\n    width: 16px;\n    height: 16px;\n    margin: 0; }\n  @media (max-width: 576px) {\n    .backButton__button___b7gT5 {\n      flex: 1; } }\n", ""]);

// exports
exports.locals = {
	"button": "backButton__button___b7gT5",
	"icon": "backButton__icon___1bQU_"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/AdFormPage/StepFooter/BackButton/backButton.scss
// module id = 4667
// module chunks = 6